import { orderBy } from "lodash-es";
import { matchPath } from "react-router-dom";

import AnnouncementPageId from "@mapmycustomers/shared/enum/announcements/AnnouncementPageId";

import { ANNOUNCEMENT_PAGES } from "./announcementPages";

const PAGE_IDS = Object.keys(ANNOUNCEMENT_PAGES) as AnnouncementPageId[];

const PAGE_ID_BY_PATTERN = new Map<string, AnnouncementPageId>(
  PAGE_IDS.flatMap((pageId) =>
    ANNOUNCEMENT_PAGES[pageId].patterns.map((pattern): [string, AnnouncementPageId] => [
      pattern,
      pageId,
    ])
  )
);

const REGISTERED_PATTERNS = Array.from(PAGE_ID_BY_PATTERN.keys());

export const isKnownPageId = (value: string): value is AnnouncementPageId =>
  PAGE_IDS.includes(value as AnnouncementPageId);

// A sub-page returns its own path, never its section's.
export const getNavigablePathForPageId = (pageId: string): string | undefined =>
  isKnownPageId(pageId) ? ANNOUNCEMENT_PAGES[pageId].navigablePath : undefined;

// A page id is a section: it also covers every id built from it plus "-".
export const matchesPage = (current: string | undefined, target: string): boolean =>
  current !== undefined && (current === target || current.startsWith(`${target}-`));

const getSegments = (pattern: string) => pattern.split("/").filter(Boolean);

// More segments win; on a tie, more static segments win.
export const findMostSpecificPattern = (pathname: string, patterns: string[]): string | undefined =>
  orderBy(
    patterns.filter((pattern) => matchPath(pathname, { path: pattern })),
    [
      (pattern) => getSegments(pattern).length,
      (pattern) => getSegments(pattern).filter((segment) => !segment.startsWith(":")).length,
    ],
    ["desc", "desc"]
  )[0];

export const resolvePageIdFromPathname = (pathname: string): AnnouncementPageId | undefined => {
  const pattern = findMostSpecificPattern(pathname, REGISTERED_PATTERNS);
  return pattern === undefined ? undefined : PAGE_ID_BY_PATTERN.get(pattern);
};
